module.exports = __webpack_public_path__ + "img/c34.1e6758ac.png";